<template>
  <section class="hp-section hp-faq hp-animate">
    <div class="container">
      <h2 class="hp-section__title text-center mb-2">Frequently asked questions</h2>
      <p class="hp-section__subtitle text-center hp-faq__intro">Everything you need to know about Hireclap and visume</p>

      <div class="hp-faq__list">
        <div
          class="hp-faq__item"
          v-for="item in items"
          :key="item.id"
        >
          <button
            type="button"
            class="hp-faq__question"
            :class="{ 'hp-faq__question--open': openId === item.id }"
            :aria-expanded="openId === item.id"
            @click="toggle(item.id)"
          >
            <span>{{ item.question }}</span>
            <span class="hp-faq__icon" aria-hidden="true">{{ openId === item.id ? '−' : '+' }}</span>
          </button>
          <div class="hp-faq__answer" v-show="openId === item.id">
            <p v-for="(paragraph, idx) in item.answers" :key="idx">{{ paragraph }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { HOME_FAQ_ITEMS } from '@/constants/homePageData';

export default {
  name: 'HomeFaq',
  data() {
    return {
      openId: 'hp-faq-a',
      items: HOME_FAQ_ITEMS,
    };
  },
  methods: {
    toggle(id) {
      this.openId = this.openId === id ? null : id;
    },
  },
};
</script>
